export const adSample = require('./ad.example.json');

export { shortcuts } from './shortcuts';
